module.exports = __webpack_public_path__ + "assets/img/home-swiper-2.08cbe944.png";